import type { ProjectItem } from '@customink/project-service-react-components';
import { useCreateProjectItem } from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import { useCallback } from 'react';

const { CORE_ORDER } = SYNC_STRATEGIES;

export const useCreateItem = () => {
  const [trigger, result] = useCreateProjectItem();
  const curriedTrigger = useCallback(
    (projectItem: Partial<ProjectItem>) => trigger(projectItem, CORE_ORDER),
    [trigger],
  );
  return [curriedTrigger, result] as const;
};
